import React from 'react'
import './plans_401k_lifeinsurance.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, SuccessStories,
    FindAgent,
    PageHeaderIntro,
    CustomerExperience
} from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
const Plans401kAndInsurance = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "401(k) plans and life insurance", link: "" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "#/",
            label: "The Sentry difference",
        },
        {
            id: "coverages",
            href: "#/",
            label: "Business auto coverages",
        },
        {
            id: "help",
            href: "#/",
            label: "Who we've helped",
        },
    ];

    const sectrydata = {
        banner: images['two_people_holding_hands.avif'],
        heading: 'The Sentry difference',
        subheading: 'Planned and prepared',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'We have the experience to serve you',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['Icon_graph_on_paper_and_coin.svg']
    }
    const plansData = {
        blue_heading: 'Working together',
        blue_para: 'As the business world incorporates new technology, insurance providers need to keep pace. With coverages for electronic data processing, computer-related losses, and more, we’re doing exactly that.',
        purple_icon: images['Icon_of_two_green_chairs.svg'],
        purple_heading: 'More than just plans and policies',
        purple_para: "If you need to file a claim, our claims staff is ready to help you 24/7.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: '401(k) and other retirement plans',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '/what-we-offer/insurance-products/401k-plans-and-life-insurance/401k-plans',
            linkText: 'More about 401(k) plans >',
        },
        {
            id: 2,
            title: 'Business life insurance',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about business life insurance >',
        },
        {
            id: 3,
            title: 'Individual life insurance',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about individual life insurance >',
        },

    ];
    const HeaderData = [
        {
            image: images['talking_blue.svg'],
            para: 'It’s impossible to predict the future, which is why it’s so hard to plan for. How much money do I need to retire? How do I help my employees reach their retirement goals? Will I even live until retirement? What will happen to my family and business after I pass away? Those are just a few of the questions you might be asking yourself. We’re here to help you answer those questions and be better prepared for the future.',
        },
    ];
    return (
        <>
            <div className='plans401k_and_insurance'>
                {/* hero section */}
                <Hero img={images["child_and_parent_walking_on_beach_under_umbrella.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="401(k) plans and life insurance" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} />

                    {/* Header intro section */}
                    <PageHeaderIntro Data={HeaderData} heading="" />

                    {/* the sentry card */}
                    <SentryCard data={sectrydata} />
                    {/* Plans section */}
                    <Plans data={plansData} />
                    {/* news card section */}
                    <NewsCard Title="Our retirement and life insurance options
                        "CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                </Container>

                {/* Video section */}
                <CustomerExperience />
                {/* news  */}
                <Container>
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default Plans401kAndInsurance;